import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Form, Select, Spin, message, Table, InputNumber, Button, Typography } from 'antd';
import dayjs from 'dayjs';
import styles from './index.module.less';
import { httpAchieveDepartmentDelete, httpAchieveDepartmentSave, httpAchieveDepartmentSaveBatch, httpAchieveDepartmentShowForDept, httpAchieveDepartmentUpdate, httpAchievementDateList } from '@/services/customerServices';
import { SDrawerOrModal, STriggerModal } from 'shj-components';
import { getUser } from '@/common/utils.ts'

const { Option } = Select;

interface Props {
  id?: number | undefined;
  setVisible: (value: boolean) => void;
  visible: boolean;
  listRef: any;
  editData: any;
  deptRef: React.MutableRefObject<any>;
}

interface Item {
  id?: number;
  idealAmount: number;
  strategyAmount: number;
  dept: string;
  key: number;
  deptName?: string;
}

interface tableCellProps {
  key: number;
  editing: boolean;
  dataIndex: string;
  title: any;
  record: Item;
  index: number;
  children: React.ReactNode;
  inputType: 'number' | any;
  dept: any;
}
const EditableCell: React.FC<tableCellProps> = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  dept,
  ...restProps
}) => {
  inputType != 'number' && console.log(dataIndex, children, 123)
  const inputNode =
    inputType && inputType != 'number' ? (
      <Select allowClear showSearch
                filterOption={(input, option: any) => {
                  return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }}>
        {inputType.current.map((item: any, i: number) => (
          <Option key={i} value={item.id}>
            {item.departmentName}
          </Option>
        ))}
      </Select>
    ) : (
      <InputNumber style={{ width: '100%' }} min={0.001} precision={3}/>
    );

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex == 'deptName' ? 'dept' : dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: true,
              message: `请输入 ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
          dataIndex == 'deptName' ? inputType.current?.find((item) =>  item.id === record.dept)?.departmentName : children
      )}
    </td>
  );
};
const EditableTable: React.FC<any> = (props: any) => {
  const { id, btnDisabled, add, dept, categoryCode, companyCode, workNumber, formRef, dataRef, tableForm, check } =
    props;
  const [form] = Form.useForm();
  tableForm.current = form;
  const [init, setInit] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<Item[]>([]);
  dataRef.current = { setData, data };
  const [editingKey, setEditingKey] = useState<number>(-999999);

  const isEditing = (record: Item) => record.key === editingKey;

  const ref = () => dept;
  const edit = (record: Partial<Item> & { key: React.Key }) => {
    form.setFieldsValue({ dept: null, idealAmount: null, strategyAmount: null, ...record });
    btnDisabled(true);
    setEditingKey(record.key);
  };

  const cancel = () => {
    setEditingKey(-999999);
    btnDisabled(false);
  };
  const addData = (val: any[]) => {
    val.push({ key: val.length + 1 });
    setData([...val]);
    edit(val[val.length - 1]);
  };
  const del = (key: React.Key) => {
    const id = data[Number(key) - 1].id || ''
    if (data[Number(key) - 1].id) {
      setLoading(true);
      httpAchieveDepartmentDelete(id).then(() => {
        data.splice(Number(key) - 1, 1);
        data.map((item: any, i: number) => {
          item.key = i;
        });
        setData([...data]);
      }).finally(() => {
        setLoading(false);
      });
    } else {
      data.splice(Number(key) - 1, 1);
      data.map((item: any, i: number) => {
        item.key = i;
      });
      setData([...data]);
    }
    btnDisabled(false);
  };
  const save = async (key: React.Key) => {
    try {
      const row = (await form.validateFields()) as Item;
      const newData = [...data];
      const index = newData.findIndex((item) => key === item.key);
      const _yearMonth = formRef.getFieldValue('yearMonth')?.split('*');
      setLoading(true);
        console.log(row,id, 'row')
      if (id) {
        httpAchieveDepartmentUpdate({
          id: newData[index].id ? newData[index].id : '',
          idealAmount: row.idealAmount,
          strategyAmount: row.strategyAmount,
          workNumber: workNumber,
          status: 'DRAFT',
        }).then((resp: any) => {
          newData.splice(index, 1, {
            dept: newData[index].dept,
            idealAmount: row.idealAmount,
            strategyAmount: row.strategyAmount,
            id: newData[index].id,
            key: Number(key),
            deptName: newData[index].deptName,
          });
          message.success(resp.message || '操作成功', 6);
          setRefresh(!refresh);
          setData([...newData]);
          setEditingKey(-999999);
          btnDisabled(false);
        }).finally(() => {
          setLoading(false);
        });
      } else {
        const _list = [...props.dept.current];
        const departmentName = _list.filter((d) => d.code == row.dept);

        httpAchieveDepartmentSave({
          id: newData[index].id ? newData[index].id : '',
          category: categoryCode,
          companyCode: companyCode,
          departmentCode: row.dept,
          idealAmount: row.idealAmount,
          strategyAmount: row.strategyAmount,
          workNumber: workNumber,
          performanceCycleMonthId: _yearMonth?.[1],
          yearMonth: _yearMonth?.[0],
          departmentName: departmentName[0]?.name,
        }).then(function (resp: any) {
          if (index > -1) {
            const _dept = row.dept;
            let _deptName = '';
            dept.current.map((item: any) => {
              if (_dept == item.code) {
                _deptName = item.name;
              }
            });
            newData.splice(index, 1, {
              dept: row.dept,
              idealAmount: row.idealAmount,
              strategyAmount: row.strategyAmount,
              id: resp,
              key: Number(key),
              deptName: _deptName,
            });
          }
          message.success(resp.message || '操作成功', 6);
          setRefresh(!refresh);
          setData([...newData]);
          setEditingKey(-999999);
          btnDisabled(false);
        }).finally(() => {
          setLoading(false);
        });
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };
  const columns: any[] = [
    {
      title: '部门',
      dataIndex: 'deptName',
      className: 'columnsCenter',
      width: '160px',
      editable: id || check ? false : true,
    },
    {
      title: '战略目标（万）',
      dataIndex: 'strategyAmount',
      width: '160px',
      className: 'columnsCenter',
      editable: check ? false : true,
    },
    {
      title: '理想目标（万）',
      dataIndex: 'idealAmount',
      width: '160px',
      className: 'columnsCenter',
      editable: check ? false : true,
    },
  ];
  if (!check) {
    columns.push({
      title: '操作',
      key: 'action',
      width: '200px',
      className: 'columnsCenter',
      render: (_: any, record: Item) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Button onClick={() => save(record.key)} style={{ marginRight: 8 }}>
              保存
            </Button>
            <Button danger onClick={() => del(record.key)} style={{ marginRight: 8 }}>
              删除
            </Button>
          </span>
        ) : (
          <Typography.Link disabled={editingKey != -999999} onClick={() => edit(record)}>
            修改
          </Typography.Link>
        );
      },
    });
  }
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: Item) => {
        return {
          record,
          inputType: col.dataIndex == 'deptName' ? ref() : 'number',
          dataIndex: col.dataIndex,
          title: '',
          editing: isEditing(record),
        };
      },
    };
  });

  useEffect(() => {
    setEditingKey(-999999)
  }, [id])

  useEffect(() => {
    if (!init) {
      setInit(true);
      return;
    }
    addData(data);
  }, [add]);
  return (
    <Form form={form} component={false}>
      <Table
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        size='small'
        rowKey="key"
        bordered
        dataSource={data}
        loading={loading}
        columns={mergedColumns}
        rowClassName="editable-row"
        pagination={{
          onChange: cancel,
        }}
      />
    </Form>
  );
};

const AddOrEdit: React.FC<Props> = ({ editData, id, visible, setVisible, listRef, deptRef, ...rest }) => {
  const tableForm = useRef<any>();
  const dataRef = useRef<any>();
  const [form] = Form.useForm();
  const [btn, setBtn] = useState(false);
  const [add, setAdd] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [title, setTitle] = useState<any>({});
  const [categoryCode, setCategoryCode] = useState<string>('performanceTypeAchievement');
  const [monthYearArr, setMonthYearArr] = useState<any[]>([]);
  const userInfo: any = getUser();

  const onFinish = () => {
    setAdd(!add);
  };

  const onOk = async () => {
    if (editData.check) {
      setVisible(false);
      return;
    }
    if (id == undefined) {
      if (dataRef.current.data.length == 0) {
        message.success('请至少添加一条数据', 6);
        return;
      }
      try {
        await tableForm.current.validateFields();
        let flag = true;
        dataRef.current.data.map((item: any) => {
          if (!item.idealAmount || !item.strategyAmount || !item.dept) {
            flag = false;
          }
        });
        if (!flag) {
          message.success('请先保存单条数据', 6);
          return;
        }
        setLoading(true);
        const _data: any = [];
        let _date = form.getFieldsValue().yearMonth;
        _date = _date?.split('*');
        dataRef.current.data.map((d: any) => {
          _data.push({
            ...d,
            departmentName: d.deptName,
            departmentCode: d.dept,
            yearMonth: _date[0],
            performanceCycleMonthId: _date[1],
          });
        });

        httpAchieveDepartmentSaveBatch(_data)
          .then(() => {
            listRef.current.reload();
            setVisible(false);
          })
          .finally(() => {
            setLoading(false);
            dataRef.current.setData([]);
          });
      } catch (errInfo) {
        console.log('Validate Failed:', errInfo);
      }
    } else {
      try {
        await tableForm.current.validateFields();
        let flag = true;
        dataRef.current.data.map((item: any) => {
          if (!item.idealAmount || !item.strategyAmount || !item.dept) {
            flag = false;
          }
        });
        if (!flag) {
          message.success('请先保存单条数据', 6);
          return;
        }
        setLoading(true);
        const _dataItem = dataRef.current.data[0];
        httpAchieveDepartmentUpdate({
          id: _dataItem.id,
          idealAmount: _dataItem.idealAmount,
          status: 'DRAFT',
          strategyAmount: _dataItem.strategyAmount,
          workNumber: userInfo.workerNumber,
        })
          .then(() => {
            listRef.current.reload();
            setVisible(false);
          })
          .finally(() => {
            setLoading(false);
            dataRef.current.setData([]);
          });
      } catch (errInfo) {
        console.log('Validate Failed:', errInfo);
      }
    }
  };
  const onCancel = useCallback(() => {
    dataRef.current.setData([]);
    setVisible(false);
  }, []);
  const onChange = (value: any) => {
    dataRef.current.setData([]);
    httpAchieveDepartmentShowForDept(`${value.yearMonth?.split('*')[1]}`, {orgId: userInfo?.companyId}).then((resp: any) => {
      setTitle(resp);
    });
  };

  useEffect(() => {
    if (id != undefined) {
      form.setFieldsValue({ yearMonth: editData.yearMonth + '*' + editData.performanceCycleMonthId });
      setTitle({
        name: editData.companyName,
        strategyAmount: editData.strategyAmount,
        idealAmount: editData.idealAmount,
        yearMonth: editData.yearMonth,
      });
      const _data: Item[] = [
        {
          idealAmount: editData.idealAmount,
          strategyAmount: editData.strategyAmount,
          key: 1,
          dept: editData.departmentCode,
          deptName: editData.departmentName,
          id: editData.id,
        },
      ];
      dataRef.current.setData(_data);
    } else {
      setBtn(false);
      form.setFieldsValue({ yearMonth: undefined });
      setTitle({ name: userInfo?.companyName });
    }
  }, [editData]);

  useEffect(() => { 
    if (userInfo && userInfo?.companyId) {
      console.log(userInfo);
      
      httpAchievementDateList(
        {
          category: categoryCode,
          companyId: userInfo?.companyId,
        }
      ).then((resp: any) => {
        console.log(resp);
        
        setMonthYearArr(resp || []);
      });
    } else {
      message.warning('未设置部门信息');
    }
  }, []);

  const yearChange = (value) => {
    setBtn(false);
  }
  return (
    <SDrawerOrModal
      title={id ? '编辑' : '新增'}
      onCancel={()=>{
        onCancel?.()
      }}
      onOk={onOk}
      open={visible}
      antdProps={editData.check ? { footer: null,destroyOnClose:true } : {destroyOnClose:true}}
    >
        <div className={styles.p}>
          <div>{`门店：${title.name ? title.name : '--'} `}</div>
          <div>{`门店战略目标：${title.strategyAmount ? title.strategyAmount : '--'}万`}</div>
          <div>{`门店理想目标：${title.idealAmount ? title.idealAmount : '--'}万`}</div>
        </div>
        {id ? (
          <div className={styles.p} >
            <div>{`年月：${title.yearMonth} `}</div>
          </div>
        ) : null}
        <Form
          wrapperCol={{ span: 18 }}
          onValuesChange={onChange}
          layout="inline"
          form={form}
          preserve={false}
          onFinish={onFinish}
        >
          {id ? null : (
            <>
              <Form.Item name="yearMonth" label="年月" rules={[{ required: true, message: '不能为空' }]} style={{marginBottom:'12px'}} >
                <Select style={{ width: 150 }} onChange={yearChange} >
                  {monthYearArr && monthYearArr.map((item: any, index: number) => {
                    return (
                      <Option
                        key={index}
                        value={
                          item.year
                            ? dayjs(item.year + '-' + item.month).format('YYYY-MM') + '*' + item.id
                            : ''
                        }
                      >
                        {item.year ? dayjs(item.year + '-' + item.month).format('YYYY-MM') : '时间格式出错'}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item>
                <Button disabled={btn} htmlType="submit" type="primary">
                  添加
                </Button>
              </Form.Item>
            </>
          )}
        </Form>
        <EditableTable
          dataRef={dataRef}
          btnDisabled={setBtn}
          add={add}
          dept={deptRef}
          categoryCode={categoryCode}
          companyCode={userInfo?.companyId}
          workNumber={userInfo.workerNumber}
          formRef={form}
          id={id}
          tableForm={tableForm}
          check={editData.check}
        />
    </SDrawerOrModal>
  );
};

export default AddOrEdit;
